import { Theme } from '@material-ui/core/styles';
import { ColorPath } from '../theme/tools/theme.model';

// pick color of income based on + | - | 0
export const handleIncomeColor = (value: number, theme: Theme, isIncome = false): string => {
  const { greys, greens, reds } = theme.color;
  if (!isIncome) {
    return greys[80];
  }
  if (value > 0) {
    return greens[100];
  }
  if (value < 0) {
    return reds[100];
  }
  return greens[100];
};

// pick color key of income based on + | - | 0 for Typography textColor prop
export const getIncomeTextColorKey = (value: number, isIncome = false): ColorPath | undefined => {
  if (!isIncome) {
    return undefined;
  }
  if (value > 0) {
    return 'greens.100';
  }
  if (value < 0) {
    return 'reds.100';
  }
  return 'greens.100';
};

export type FontSizeType = 's' | 'base' | 'm' | 'l' | 'xl' | 'xxl' | 'xxxl' | 'xxxlLg' | 'xxxxl' | 'subHeadline2';

//Function for shorthand css background property
export const bgShorthand = (
  image: Object,
  repeatValue: string,
  positionX: string | number,
  positionY: string | number,
  size: string | number
  ) => {
    const fontSize:string = typeof size === 'string' ? `${size} ` : `${size}% `;
    return ` url(${image}) ${repeatValue}  ${positionX} ${positionY} /${fontSize}`;
  };


export function conditionalProperties<T>(condition: (args: T) => boolean, properties: { [key: string]: unknown }): object {
  return Object.keys(properties).reduce(
    (all, property: string) => (
      {...all, [property]: (args: T) => condition(args)
        ? properties[property]
        : null}
    ),
    {});
}